import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@wb/core/services/auth.service';
import { first, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.sass'],
})
export class NoAccessComponent implements OnInit, OnDestroy {
  public visible = false;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    this.auth.userRoles$
      .pipe(
        first((result) => !!result),
        takeUntil(this.destroyed$),
      )
      .subscribe(() => {
        this.visible = true;
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
